export const environment = {
  production: true,
  buildId: '3063836013120281',
  configFile: 'config.json',
};
